import {IImmoConnDataOneWireItem} from "./iotMaxxGateway.response";

export enum GatewayType {
  SM01 = 'SM01',
  SM02 = 'SM02',
  SM03 = 'SM03',
  SM04 = 'SM04',
  SM05 = 'SM05',
  OTM01 = 'OTM01',
  OTM02 = 'OTM02',
  OTM03 = 'OTM03',
  HSC = 'HSC',
  HCHC = 'HCHC',
}

export const isReadOnlyModuleType = (type: string): boolean =>
  type === GatewayType.HSC || type === GatewayType.HCHC;

export const isSameModuleType = (a: string, b: string): boolean =>
  a === b || (isReadOnlyModuleType(a) && isReadOnlyModuleType(b));

export interface IModuleConfig {
  timestamp: string,
  id: string,
  serialConfig: {
    port: {
      id: number,
      baudrate: number,
      parity: string,
      mb_timeout: number
    }
  },
  configInfo: {
    locationID: string,
    description: string
  },
  uvsModule: {
    typ: GatewayType,
    address: number,
    onChangeMsg: boolean,
    currentLoopThreshold?: number[],
    lightThreshold?: number,
    lekageThreshold?: number,
    temperatureThreshold?: number,
    w1: {
      typ: string,
      name: string,
      unit: string
    }[],
    sensorTypeName?: string,
    sensorParameters?: {
      b: number,
      referenceResistance: number
    },
    measuredValues?: {
      sensorResistance: number,
      outsideTemperature: number,
      temperatureDisplayedByHeatingSystem: number
    }
  }[]
}

export interface IDeviceData {
  timestamp: string,
  id: string,
  uvsModule: IUvsModule[]
}

export interface IUpdateIrValuesResponse {
  id: string,
  msg: string
}

export interface IImplementedMetersResponse {
  id: string,
  msg: string,
  implementedMeters: string[]
}

export interface IUvsModule {
  moduleInfo: IUvsModuleModuleInfo,
  w1: IJucOneWireItem[],
  currentLoop: number[],
  leakage: number[],
  pfc: number[],
  light: number[],
  impulse: number[],
  irUart: {
    input: number,
    type: string,
    data: {
      serverId: string,
      timestamp: number,
      "1-0:1.8.0*255": number,
      "1-0:2.8.0*255": number,
      "1-0:3.0.0*255": number
    } | {
      manufacturer: string,
      Wh: number,
      dm3: number,
      serial: string,
      time: string
    },
    errorMsg: string
  }[],
  OTM: IOtmModule
}

export interface IJucOneWireItem extends IImmoConnDataOneWireItem {
  powerW1: number
}

export interface IOtmModule {
  measTemp: number;
  offRes: number;
  offTemp: number;
  simRes: number;
  simTemp: number;
  state: number;
  mode: number;
  measRes: number;
  sensor: string;
}

export interface IUvsModuleModuleInfo {
  error: boolean,
  modulID: string,
  fwVersion: string,
  uvsType: GatewayType,
  address: number,
  errorMsg: string
}
